export enum TEXT_INPUT {
    MAX_LENGTH = 100,

}

export enum TEXT_FIELD {
    MAX_LENGTH = 200
}

export enum UPLOAD_FILE {
    MAX_COUNT = 3,
}